import React from 'react';
import './LoadingButton.css';

/**
 * LoadingButton Component
 * Button with loading state and configurable loading text
 */
const LoadingButton = ({ 
  children, 
  loading = false, 
  loadingText = 'Loading...',
  className = '', 
  disabled = false,
  ...props 
}) => {
  return (
    <button
      className={`loading-button ${className} ${loading ? 'loading' : ''}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <>
          <span className="loading-spinner"></span>
          <span className="loading-text">{loadingText}</span>
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
